import { z } from "zod";

import { machineTypeSchema } from "../machine-type";
import { machineBaseSchema } from "../machine-base";

export const lantechMachineSchema = machineBaseSchema.extend({
	machineType: z.literal(machineTypeSchema.enum.LantechCaseSealer),
});

// TODO @eb remove this function when the Lantech aligns with our decided upon schemas
export const prepareLantechMachineData = (data: unknown): unknown => {
	if (typeof data !== "object" || data === null) {
		return data;
	}

	const input = data as Record<string, unknown>;

	const iotDevice = {
		deviceId: input.iotDeviceId ?? "",
		deviceName: input.iotEdgeDeviceId ?? "",

		hubName: input.iotHubName ?? "",
		moduleId: input.iotEdgeModuleId ?? "",
		moduleVersion: input.edgeModuleVersion ?? "",
		lastProofOfLife: input.lastProofOfLifeTimeStamp,
	};

	const activeStopReason = input.activeStopReason as Record<string, unknown>;
	let stopReason: {
		stopCode: number;
		message: string;
		arguments: number[];
		isError: boolean;
	} = { stopCode: 0, message: "", arguments: [], isError: false };
	if (typeof activeStopReason === "object" && activeStopReason !== null) {
		stopReason = {
			stopCode: (activeStopReason.stopCode as number) ?? 0,
			message: (activeStopReason.message as string) ?? "",
			arguments: [activeStopReason.argument ?? undefined].filter((a) => a !== undefined).map(Number),
			isError: activeStopReason.isError === true,
		};
	}

	let activeWarnings = Array.isArray(input.warnings) ? input.warnings : [];
	activeWarnings = activeWarnings.map((w: Record<string, unknown>) => ({
		message: w.message,
		code: w.code,
		arguments: [w.argument ?? undefined].filter((a) => a !== undefined).map(Number),
	}));

	let workstations = input.workstations;
	if (!Array.isArray(workstations) || workstations.length < 1) {
		const activeErrors = Array.isArray(input.errors) ? input.errors : [];

		workstations = [
			{
				number: 1,
				alarms: activeErrors.map((e: Record<string, unknown>) => ({
					code: e.code,
					message: e.message,
					arguments: [e.argument ?? undefined].filter((a) => a !== undefined).map(String),
				})),
				warnings: activeWarnings.map((w: Record<string, unknown>) => ({
					...w,
					arguments: Array.isArray(w.arguments) ? w.arguments.map(String) : [],
				})),
				stopReason: {
					code: stopReason.stopCode,
					message: stopReason.message,
					arguments: stopReason.arguments.map(String),
					isError: stopReason.isError,
				},
			},
		];
	}

	return {
		...input,
		machineType: "LantechCaseSealer",
		assetId: input.assetId?.toString() ?? "",
		description: input.description ?? "",
		plcVersion: input.plcVersion ?? "",
		iotDevice,
		stopReason,
		activeWarnings,
		workstations,
	};
};

export type LantechMachine = z.infer<typeof lantechMachineSchema>;
